/**
 * «Editar categoría»: la página que reúne una familia (`/services`,
 * `/bookings`, `/digital`, `/products`) se diseña y se ajusta en el editor.
 *
 * Aquí hubo una pantalla entera de «Página pública» —publicarla, barra y pie,
 * titular, colores, columnas…—, y todo eso ya lo hace el lienzo: una página
 * diseñada allí manda sobre la automática y aquella pantalla dejaba de contar.
 * Publicarla o no es «Publicar esta página» en sus ajustes del editor. El
 * editor la abre con `?catalog=<familia>` y la crea con su diseño la primera
 * vez.
 */
import { IconLayout } from '@tabler/icons-react'
import type { CatalogKind } from '../../../lib/api'
import { editorHref } from '../../../lib/editorSession'
import { useI18n } from '../../../lib/i18n'

/** `record=page`: el enlace viejo a aquella pantalla. Se ignora y se limpia. */
export const LEGACY_CATALOG_PAGE_RECORD = 'page'

export function CatalogPageButton({ projectId, kind }: { projectId: string; kind: CatalogKind }) {
  const { t } = useI18n()
  const label = t(`catalogPage.${kind}.editPage`)
  return (
    <a
      className="dash-secondary-btn dash-catalog-page-btn"
      aria-label={label}
      title={t(`catalogPage.${kind}.editPageHint`)}
      href={editorHref(`?pid=${encodeURIComponent(projectId)}&catalog=${kind}`)}
    >
      <IconLayout size={15} aria-hidden="true" />
      <span aria-hidden="true">{label}</span>
    </a>
  )
}
